export const onMobile = !!(navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);

export const isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') !== -1;

export const CDN_HOST = 'https://cdn.higherlogic.com';
